<template>
  <div id="main" style="width: 900px;height:1500px;padding-left: 250px;border: 1px solid rgb(102 102 102);"></div>
</template>
<script>
import * as echarts from "echarts";
export default {
  name: "TicketFlowChart",
  data() {
    return {

    }
  },
  mounted() {
    this.setFlowCharts()
  },
  methods: {
    setFlowCharts() {
      const myChart = echarts.init(document.getElementById('main'));
      const data = [
        {
          name: 'A',
          x: 100,
          y: 100,
        }, {
          name: 'B',
          x: 100,
          y: 200,
          tooltip: {
            show: true,
            position: 'right',
            textStyle: {
              width: 20
            },
            formatter: function(params) {
              return params.dataType == 'node' ? '鼠标悬停的显示的内容' : '';
            }
          },
        }, {
          name: 'C',
          x: 200,
          y: 100,
        },{
          name: 'D',
          x: 200,
          y: 200,
        },
      ]
      const links = [
        {
          source: 'A',
          target: 'B',
          lineStyle: {
            color: '#473C8B',
            width: 3,
          },
        }, {
          source: 'B',
          target: 'C',
          lineStyle: {
            color: '#473C8B',
            width: 3,
          },
          label: {
            show: true,
            position: 'middle',
            formatter: '有疑问',
            fontSize: 15,
          },
        }, {
          source: 'B',
          target: 'D',
          lineStyle: {
            color: '#473C8B',
            width: 3,
          },
          label: {
            show: true,
            position: 'middle',
            formatter: '完成',
            fontSize: 15
          },
        }
      ]
      const option = {
        title: {
          text: '流程'
        },
        series: [
          {
            type: 'graph',
            layout: 'none',
            symbolSize: 100,
            roam: true,
            color: '#ffffff',
            label: {
              show: true,
              fontSize: 16,
              color: '#000000',
              backgroundColor:'white'
            },
            symbol: 'roundRect',
            edgeSymbol: ['circle', 'arrow'],
            edgeSymbolSize: [4, 10],
            edgeLabel: {
              fontSize: 25
            },
            data: data,
            links: links
          }
        ]
      }
      myChart.setOption(option,true);
    }
  }
}
</script>
<style scoped>

</style>